export default function generateFileName (fileName) {
  return Math.random().toString(36).substring(4).concat('.').concat(fileName.split('.').pop())
}
